"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9638],{

/***/ 16274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 19V7.83001L17.88 12.71C18.27 13.1 18.91 13.1 19.3 12.71C19.69 12.32 19.69 11.69 19.3 11.3L12.71 4.71001C12.32 4.32001 11.69 4.32001 11.3 4.71001L4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7C5.08997 13.09 5.71997 13.09 6.10997 12.7L11 7.83001V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 60526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.00012 16.2L5.50012 12.7C5.11012 12.31 4.49012 12.31 4.10012 12.7C3.71012 13.09 3.71012 13.71 4.10012 14.1L8.29012 18.29C8.68012 18.68 9.31012 18.68 9.70012 18.29L20.3001 7.70001C20.6901 7.31001 20.6901 6.69001 20.3001 6.30001C19.9101 5.91001 19.2901 5.91001 18.9001 6.30001L9.00012 16.2Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 24930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tag_Tag; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/types.ts
var variants = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    SUCCESS: "success",
    TEXTDISABLED: "textDisabled",
    TEXTSUBTLE: "textSubtle",
    BINANCE: "binance",
    FAILURE: "failure",
    WARNING: "warning"
};
var scales = {
    MD: "md",
    SM: "sm"
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/theme.ts


var _obj;
var scaleVariants = (_obj = {}, (0,_define_property/* default */.Z)(_obj, scales.MD, {
    height: "28px",
    padding: "0 8px",
    fontSize: "14px"
}), (0,_define_property/* default */.Z)(_obj, scales.SM, {
    height: "24px",
    padding: "0 4px",
    fontSize: "12px"
}), _obj);
var _obj1;
var styleVariants = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, variants.PRIMARY, {
    backgroundColor: "primary",
    bg: ""
}), (0,_define_property/* default */.Z)(_obj1, variants.SECONDARY, {
    backgroundColor: "secondary",
    bg: ""
}), (0,_define_property/* default */.Z)(_obj1, variants.SUCCESS, {
    backgroundColor: "success",
    bg: ""
}), (0,_define_property/* default */.Z)(_obj1, variants.TEXTDISABLED, {
    backgroundColor: "textDisabled",
    bg: ""
}), (0,_define_property/* default */.Z)(_obj1, variants.TEXTSUBTLE, {
    backgroundColor: "textSubtle",
    bg: "#2D2B38"
}), (0,_define_property/* default */.Z)(_obj1, variants.BINANCE, {
    backgroundColor: "binance",
    bg: ""
}), (0,_define_property/* default */.Z)(_obj1, variants.FAILURE, {
    backgroundColor: "failure",
    bg: " #FFCEC7"
}), (0,_define_property/* default */.Z)(_obj1, variants.WARNING, {
    backgroundColor: "warning",
    bg: ""
}), _obj1);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/StyledTag.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-radius: 16px;\n  color: #ffffff;\n  display: inline-flex;\n  font-weight: 400;\n  white-space: nowrap;\n\n  & > svg {\n    fill: currentColor;\n  }\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getOutlineStyles = function getOutlineStyles(param) {
    var outline = param.outline, theme = param.theme, tmp = param.variant, variantKey = tmp === void 0 ? variants.PRIMARY : tmp;
    if (outline) {
        var themeColorKey = styleVariants[variantKey].backgroundColor;
        var color = theme.colors[themeColorKey];
        return "\n      color: ".concat(color, ";\n      background: ").concat(theme.colors.background, " | ").concat(styleVariants[variantKey].bg, " ;\n      border: 2px solid ").concat(color, ";\n    ");
    }
    return "";
};
var StyledTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8109925d-0"
}).withConfig({
    componentId: "sc-79bc55e0-0"
})(_templateObject(), function(param) {
    var textTransform = param.textTransform;
    return textTransform && "text-transform: ".concat(textTransform, ";");
}, (0,index_esm/* variant */.bU)({
    prop: "scale",
    variants: scaleVariants
}), (0,index_esm/* variant */.bU)({
    variants: styleVariants
}), index_esm/* space */.Dh, index_esm/* typography */.cp, getOutlineStyles);
/* harmony default export */ var Tag_StyledTag = (null);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/Tag.tsx







var Tag = function Tag(_param) /*#__PURE__*/ {
    var startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "startIcon",
        "endIcon",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(StyledTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ react.isValidElement(startIcon) && // @ts-ignore
            /*#__PURE__*/ react.cloneElement(startIcon, {
                mr: "0.5em"
            }),
            children,
            /*#__PURE__*/ react.isValidElement(endIcon) && // @ts-ignore
            /*#__PURE__*/ react.cloneElement(endIcon, {
                ml: "0.5em"
            })
        ]
    }));
};
/* eslint-disable react/default-props-match-prop-types */ Tag.defaultProps = {
    variant: "primary",
    scale: scales.MD,
    outline: false
};
/* harmony default export */ var Tag_Tag = (Tag);


/***/ }),

/***/ 41914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tz": function() { return /* binding */ AutoColumn; },
/* harmony export */   "lg": function() { return /* binding */ ColumnCenter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-auto-rows: auto;\n  grid-row-gap: ",
        ";\n  justify-items: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Column = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-0"
})(_templateObject());
var ColumnCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Column).withConfig({
    componentId: "sc-91e5cc43-1"
})(_templateObject1());
var AutoColumn = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-2"
})(_templateObject2(), function(param) {
    var gap = param.gap;
    return gap === "sm" && "8px" || gap === "md" && "12px" || gap === "lg" && "24px" || gap;
}, function(param) {
    var justify = param.justify;
    return justify;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Column);


/***/ }),

/***/ 39475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ AutoRow; },
/* harmony export */   "DA": function() { return /* binding */ RowFixed; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* unused harmony export RowFlat */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44850);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: wrap;\n  margin: ",
        ";\n  justify-content: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: fit-content;\n  margin: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2ce7e6d-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "center";
}, function(param) {
    var justify = param.justify;
    return justify !== null && justify !== void 0 ? justify : "flex-start";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
});
var RowBetween = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-2ce7e6d-1"
})(_templateObject1());
var RowFlat = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ce7e6d-2"
})(_templateObject2());
var AutoRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-2ce7e6d-3"
})(_templateObject3(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var gap = param.gap;
    return gap;
});
var RowFixed = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-2ce7e6d-4"
})(_templateObject4(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
});
/* harmony default export */ __webpack_exports__["ZP"] = (Row);


/***/ }),

/***/ 40874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pM": function() { return /* binding */ ConfirmationModalContent; },
  "PU": function() { return /* binding */ ConfirmationPendingContent; },
  "ht": function() { return /* binding */ TransactionErrorContent; },
  "rD": function() { return /* binding */ TransactionSubmittedContent; },
  "ZP": function() { return /* binding */ components_TransactionConfirmationModal; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(48732);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx + 2 modules
var Spinner = __webpack_require__(63603);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(16274);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Metamask.tsx
var Metamask = __webpack_require__(65335);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Error.tsx
var Error = __webpack_require__(44700);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/SattLogo2.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "300",
        height: "70",
        viewBox: "0 0 485 106",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64.851 56.5814H53.0351V49.9459H64.851C65.177 52.1496 65.177 54.3893 64.851 56.5931V56.5814ZM46.3762 56.5814H39.729V49.9459H46.3762V56.5814ZM23.5708 43.2753H23.3962C24.9133 40.2863 27.0923 37.6826 29.7673 35.6627C32.4424 33.6427 35.543 32.2596 38.8332 31.6186C42.1234 30.9776 45.5164 31.0957 48.7541 31.9638C51.9918 32.8319 54.9888 34.4271 57.517 36.6281H66.4459C63.0845 31.8975 58.3678 28.2972 52.9182 26.3023C47.4686 24.3074 41.5422 24.0117 35.9211 25.4542C30.3 26.8967 25.2483 30.0095 21.4327 34.382C17.6171 38.7546 15.2169 44.1812 14.5487 49.9459H33.0701V56.5931H14.5371V56.6513C14.7983 58.907 15.3299 61.1231 16.1203 63.2519H33.0585V80.2134C35.2064 81.0091 37.442 81.5445 39.7174 81.8082V63.2403H46.3646V81.7733C48.6397 81.5083 50.8751 80.9729 53.0234 80.1785V63.2403H69.9616C72.3369 56.7973 72.3369 49.7184 69.9616 43.2753H23.5708Z",
                fill: "#1F2349"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.0356 88.6766C36.0316 88.6766 29.1848 86.5997 23.3612 82.7085C17.5375 78.8172 12.9986 73.2865 10.3182 66.8156C7.63792 60.3447 6.93662 53.2243 8.30304 46.3549C9.66946 39.4854 13.0422 33.1754 17.9948 28.2228C22.9474 23.2703 29.2574 19.8975 36.1268 18.5311C42.9963 17.1646 50.1167 17.866 56.5876 20.5463C63.0585 23.2266 68.5892 27.7656 72.4804 33.5892C76.3717 39.4129 78.4486 46.2596 78.4486 53.2636C78.4486 62.6557 74.7176 71.6632 68.0764 78.3044C61.4352 84.9456 52.4277 88.6766 43.0356 88.6766ZM43.0356 11.1801C34.7118 11.1778 26.5742 13.644 19.6521 18.2668C12.73 22.8896 7.33419 29.4613 4.14721 37.1509C0.960222 44.8405 0.125166 53.3024 1.74765 61.4666C3.37014 69.6307 7.37728 77.1304 13.2623 83.0171C19.1473 88.9037 26.6459 92.9129 34.8096 94.5377C42.9733 96.1624 51.4355 95.3297 59.1259 92.1448C66.8163 88.96 73.3896 83.566 78.0143 76.6452C82.639 69.7243 85.1074 61.5875 85.1074 53.2636C85.109 47.7377 84.0219 42.2656 81.9083 37.1599C79.7946 32.0541 76.6959 27.4148 72.789 23.5068C68.8821 19.5988 64.2436 16.4988 59.1385 14.3838C54.0333 12.2687 48.5615 11.1801 43.0356 11.1801Z",
                fill: "#1F2349"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M126.376 48.4757C117.971 46.322 115.899 45.2743 115.899 42.0846V41.9449C115.899 39.6166 118.053 37.7191 122.15 37.7191C126.248 37.7191 130.474 39.5235 134.781 42.5037L140.334 34.4479C135.22 30.3553 128.839 28.1735 122.29 28.2779C112.36 28.2779 105.282 34.0986 105.282 42.9228V43.0625C105.282 52.7132 111.603 55.414 121.394 57.9169C129.543 60.0007 131.173 61.4092 131.173 64.0868V64.2264C131.173 67.0786 128.542 68.8131 124.188 68.8131C118.635 68.8131 114.048 66.4849 109.683 62.911L103.361 70.4779C109.047 75.512 116.384 78.2798 123.978 78.2543C134.455 78.2543 141.813 72.8294 141.813 63.1904V63.0507C141.778 54.5758 136.225 51.0368 126.376 48.4757Z",
                fill: "#1F2349"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M220.113 28.9647V38.8249H231.149V77.5558H241.836V38.8249H252.86V28.9647H220.113Z",
                fill: "#1F2349"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M185.7 38.8249H196.725V77.5558H207.411V38.8249H218.447V28.9647H185.7V38.8249Z",
                fill: "#1F2349"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M163.582 67.3113C161.832 67.3113 160.122 66.7924 158.667 65.8203C157.212 64.8481 156.078 63.4663 155.408 61.8497C154.739 60.233 154.563 58.4541 154.905 56.7379C155.246 55.0216 156.089 53.4452 157.326 52.2078C158.563 50.9705 160.14 50.1279 161.856 49.7865C163.572 49.4451 165.351 49.6203 166.968 50.2899C168.585 50.9596 169.966 52.0936 170.939 53.5485C171.911 55.0035 172.43 56.714 172.43 58.4639C172.427 60.8094 171.493 63.058 169.835 64.7166C168.176 66.3751 165.928 67.3082 163.582 67.3113ZM172.43 40.9437C169.437 39.4326 166.108 38.7132 162.759 38.8539C159.409 38.9946 156.152 39.9907 153.297 41.7474C150.442 43.5041 148.084 45.9628 146.449 48.8891C144.814 51.8153 143.955 55.1117 143.955 58.4639C143.955 61.8161 144.814 65.1125 146.449 68.0387C148.084 70.965 150.442 73.4237 153.297 75.1804C156.152 76.9371 159.409 77.9332 162.759 78.0739C166.108 78.2146 169.437 77.4952 172.43 75.9841V78.1262H183.21V38.8366H172.43V40.9437Z",
                fill: "#1F2349"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M332.536 28.6987L319.734 77.8056H305.254L297.419 45.4874L289.305 77.8056H274.824L262.373 28.6987H275.174L282.239 64.4446L290.984 28.6987H304.135L312.529 64.4446L319.664 28.6987H332.536ZM334.058 58.2188C334.058 54.2082 334.804 50.6872 336.296 47.6559C337.835 44.6246 339.91 42.2928 342.522 40.6606C345.134 39.0284 348.048 38.2123 351.266 38.2123C354.018 38.2123 356.419 38.7719 358.471 39.8911C360.57 41.0104 362.179 42.4794 363.298 44.2982V38.7719H375.26V77.8056H363.298V72.2793C362.132 74.0981 360.5 75.5671 358.401 76.6864C356.349 77.8056 353.948 78.3652 351.196 78.3652C348.025 78.3652 345.134 77.5491 342.522 75.9169C339.91 74.238 337.835 71.8829 336.296 68.8516C334.804 65.7737 334.058 62.2294 334.058 58.2188ZM363.298 58.2887C363.298 55.3041 362.459 52.949 360.78 51.2235C359.147 49.498 357.142 48.6352 354.764 48.6352C352.385 48.6352 350.357 49.498 348.678 51.2235C347.046 52.9024 346.229 55.2341 346.229 58.2188C346.229 61.2034 347.046 63.5818 348.678 65.354C350.357 67.0795 352.385 67.9422 354.764 67.9422C357.142 67.9422 359.147 67.0795 360.78 65.354C362.459 63.6285 363.298 61.2734 363.298 58.2887ZM393.777 26.0405V77.8056H381.815V26.0405H393.777ZM412.309 26.0405V77.8056H400.347V26.0405H412.309ZM455.675 57.6592C455.675 58.7784 455.605 59.9443 455.465 61.1568H428.393C428.579 63.5818 429.349 65.4473 430.701 66.753C432.1 68.0122 433.803 68.6418 435.808 68.6418C438.793 68.6418 440.868 67.3826 442.034 64.8643H454.765C454.112 67.4293 452.923 69.7377 451.198 71.7897C449.519 73.8416 447.397 75.4505 444.832 76.6164C442.267 77.7823 439.399 78.3652 436.228 78.3652C432.404 78.3652 428.999 77.5491 426.015 75.9169C423.03 74.2846 420.698 71.9529 419.019 68.9216C417.34 65.8903 416.501 62.346 416.501 58.2887C416.501 54.2315 417.317 50.6872 418.949 47.6559C420.628 44.6246 422.96 42.2928 425.945 40.6606C428.929 39.0284 432.357 38.2123 436.228 38.2123C440.005 38.2123 443.363 39.0051 446.301 40.5907C449.239 42.1763 451.524 44.4381 453.156 47.3761C454.835 50.3141 455.675 53.7418 455.675 57.6592ZM443.433 54.5113C443.433 52.4593 442.733 50.8271 441.334 49.6146C439.935 48.4021 438.186 47.7958 436.088 47.7958C434.082 47.7958 432.38 48.3787 430.981 49.5446C429.629 50.7105 428.789 52.3661 428.463 54.5113H443.433ZM481.642 67.6624V77.8056H475.556C471.219 77.8056 467.838 76.7563 465.413 74.6577C462.988 72.5125 461.775 69.0382 461.775 64.2347V48.7052H457.018V38.7719H461.775V29.2583H473.737V38.7719H481.572V48.7052H473.737V64.3746C473.737 65.5405 474.017 66.38 474.577 66.8929C475.136 67.4059 476.069 67.6624 477.375 67.6624H481.642Z",
                fill: "#7F84FF"
            })
        ]
    }));
};
/* harmony default export */ var SattLogo2 = (Icon);

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./src/utils/wallet.ts + 1 modules
var wallet = __webpack_require__(84695);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(53854);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(39475);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(41914);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var utils = __webpack_require__(38328);
;// CONCATENATED MODULE: ./src/components/TransactionConfirmationModal/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef36fa6d-0"
})(_templateObject());
var Section = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-ef36fa6d-1"
})(_templateObject1());
var ConfirmedIcon = (0,styled_components_browser_esm/* default */.ZP)(Column/* ColumnCenter */.lg).withConfig({
    componentId: "sc-ef36fa6d-2"
})(_templateObject2());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
function TransactionSubmittedContent(param) {
    var onDismiss = param.onDismiss, chainId = param.chainId, hash = param.hash, currencyToAdd = param.currencyToAdd;
    var ref;
    var library = (0,useActiveWeb3React/* default */.Z)().library;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var token = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyToAdd, chainId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmedIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                        strokeWidth: 0.5,
                        width: "90px",
                        color: "primary"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "12px",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "20px",
                            children: t("Transaction Submitted")
                        }),
                        chainId && hash && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            external: true,
                            small: true,
                            href: (0,utils/* getBscScanLink */.s6)(hash, "transaction", chainId),
                            children: t("View on BscScan")
                        }),
                        currencyToAdd && (library === null || library === void 0 ? void 0 : (ref = library.provider) === null || ref === void 0 ? void 0 : ref.isMetaMask) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "tertiary",
                            mt: "12px",
                            width: "fit-content",
                            onClick: function() {
                                return (0,wallet/* registerToken */.$P)(token.address, token.symbol, token.decimals, (0,_instanceof/* default */.Z)(token, types/* WrappedTokenInfo */.DT) ? token.logoURI : undefined);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    t("Add %asset% to Metamask", {
                                        asset: currencyToAdd.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, {
                                        width: "16px",
                                        ml: "6px"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onDismiss,
                            mt: "20px",
                            children: t("Close")
                        })
                    ]
                })
            ]
        })
    });
}
function ConfirmationModalContent(param) {
    var bottomContent = param.bottomContent, topContent = param.topContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: topContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: bottomContent()
            })
        ]
    });
}
function TransactionErrorContent(param) {
    var message = param.message, onDismiss = param.onDismiss;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                        color: "failure",
                        width: "64px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        style: {
                            textAlign: "center",
                            width: "85%",
                            wordBreak: "break-word"
                        },
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "center",
                pt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: onDismiss,
                    children: t("Dismiss")
                })
            })
        ]
    });
}
var TransactionConfirmationModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, content = param.content, currencyToAdd = param.currencyToAdd, ShowSattPasswordModal = param.ShowSattPasswordModal;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var handleDismiss = (0,react.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    if (!chainId) return null;
    if (ShowSattPasswordModal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
            minWidth: "400px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SattLogo2, {
                            mr: "1rem"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                            onDismiss: onDismiss
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
                    width: [
                        "400px",
                        null,
                        "400px"
                    ],
                    m: "2rem",
                    children: attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationPendingContent, {
                        pendingText: pendingText
                    }) : hash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionSubmittedContent, {
                        chainId: chainId,
                        hash: hash,
                        onDismiss: handleDismiss,
                        currencyToAdd: currencyToAdd
                    }) : content()
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: title,
        headerBackground: "gradients.cardHeader",
        onDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationPendingContent, {
            pendingText: pendingText
        }) : hash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionSubmittedContent, {
            chainId: chainId,
            hash: hash,
            onDismiss: handleDismiss,
            currencyToAdd: currencyToAdd
        }) : content()
    });
};
/* harmony default export */ var components_TransactionConfirmationModal = (TransactionConfirmationModal);


/***/ })

}]);